import styled from "styled-components";

export const DateRangePickerContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TriggerButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 400;
  font-family: "Geist", sans-serif;
  color: #181d27;
  border-radius: 8px;
  border: ${(props) =>
    props.$isOpen ? "1px solid #4285f4" : "1px solid #d5d7da"};
  background: #fff;
  cursor: pointer;
  padding: 8px 12px;
  box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  cursor: text;
`;

export const DropdownContainer = styled.div`
  display: ${(props) => (props.$isOpen ? "block" : "none")};
  min-width: 837px;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #e0e0e0;
  margin-top: 8px;
  border-radius: 16px;
  z-index: 99999;
  box-shadow: 0 20px 24px -4px rgba(10, 13, 18, 0.08),
    0 8px 8px -4px rgba(10, 13, 18, 0.03),
    0 3px 3px -1.5px rgba(10, 13, 18, 0.04);

  .flex-container {
    display: flex;
  }
`;

export const ScenariosPanel = styled.div`
  width: 217px;
  border-right: 1px solid #e9eaeb;
  padding: 20px 5px 20px 16px;
  display: flex;
  flex-direction: column;
  .recommendation-container {
    flex: 1;
  }
`;

export const ScenariosCardContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding-right: 20px;

  /* Scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }
`;

export const ScenariosTitle = styled.h3`
  font-size: 14px;
  font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #414651;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0px 0px;
  text-align: left;
  color: #1841dd;
  font-size: 12px;
  font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
`;

export const CalendarContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .date-picker-wraper {
    display: flex;
    justify-content: center;
    flex: 1;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid #e9eaeb;
`;

export const DateInputsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .dash {
    color: #666;
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const DateInput = styled.input`
  width: 136px;
  font-size: 16px;
  font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #181d27;
  font-weight: 400;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  &:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
  }
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 12px;
  font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  margin-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
  white-space: nowrap;
  z-index: 1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const CancelButton = styled.button`
  font-size: 14px;
  font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #414651;
  font-weight: 500;
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  background: #fff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  &:hover {
    background-color: #f8f9fa;
    border-color: #bdc1c6;
  }
`;

export const QuickDateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
`;

export const QuickDateButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const QuickDateButton = styled.button`
  font-size: 12px;
  font-family: "Geist", sans-serif;
  font-weight: 500;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid ${(props) => (props.$isActive ? "#2258f1" : "#d5d7da")};
  background: ${(props) => (props.$isActive ? "#2258f1" : "#fff")};
  color: ${(props) => (props.$isActive ? "#fff" : "#414651")};
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  &:hover {
    background-color: ${(props) => (props.$isActive ? "#3367d6" : "#f8f9fa")};
    border-color: ${(props) => (props.$isActive ? "#3367d6" : "#bdc1c6")};
  }
`;
